import { render, staticRenderFns } from "./SegmentRow.vue?vue&type=template&id=66b4a188&"
import script from "./SegmentRow.vue?vue&type=script&lang=js&"
export * from "./SegmentRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports